import { ShapeMen } from "../flowchart/men";

export class ShapePerson extends ShapeMen {
    width = 124;
    height = 200;
    needFill = false;
}
